import { Ref } from '../domain';
import { v4 as uuidv4 } from "uuid";

function uuid() :string {
    return uuidv4();
}

function assertType<T extends Function, I extends Function>(ref:any, refName:string, type:T, itemType: I | undefined = undefined) {
    if (ref === undefined) {
        throw new Error("'" + refName + "' of type " + type.name + ' expected');
    }
    if (!isOfType(ref, type)) {
        throw new Error("Ref '" + refName + "' not of type " + type.name);
    }

    if (ref.constructor.name === Array.name) {
        if (!itemType) {
            throw new Error("ItemType should defined for Array");
        }
        <Array<any>>ref.forEach((item: any) => {
            if (!isOfType(item, itemType)) {
                throw new Error("Array '" + refName + "' does not contain types '" + itemType.name + "'");
            }
        })
    }
    // else if (ref.constructor.name === Ref.name) {
    //     if (!itemType) {
    //         throw new Error("ItemType should defined for Array");
    //     }
    //     const item = <Ref<any>>ref.type;
    //     if(!isOfType(item, itemType)) {
    //         throw new Error("Ref '" + refName + "' does not contain type '" + itemType.name + "'");
    //     }
    // }
}

function createGrouping<K>(array:any[], keyFunc:(x:any) => any, valueFunc:((x:any) => any) | undefined = undefined) : Record<any, any> {
    const grouped:Record<any,any> = {};
    const valueFunction = valueFunc === undefined ? (item:any) => item : valueFunc;
    array.forEach((item:any) => {
        const key = keyFunc(item);
        if (!(key in grouped)) {
            grouped[key] = [];
        }
        grouped[key].push(valueFunction(item));
    });
    return grouped;
}


function createIndex<T,V>(array:any[], keyFunc: (x:T) => (string), valueFunc: (x:T) => V) : Record<string, V> {
    const index:Record<string, V> = {};
    array.forEach(item => {
        const key = keyFunc(item);
        index[key] = valueFunc(item);
    });
    return index;
}

function isOfType<T extends Function>(ref:any, type:T) {
    return ref.constructor.name === type.name || isOfSubType(ref, type);
}

function isOfSubType<T extends Function>(ref:any, type:T) {
    return ref instanceof type;
}

function toDateStr(date:Date) {
    return date.toISOString().slice(0,10);
}

function areNumbersEqual(num1:number, num2:number) {
    return Math.abs(num1 - num2) < 0.00001
}

export {assertType, isOfType, toDateStr, areNumbersEqual, createGrouping, createIndex, uuid};